import React from 'react';
import {
  Box,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  Text,
} from 'grommet';
import { ScoreByInningsProps } from '../hitScope.types';

const ScoreByInning: React.FC<ScoreByInningsProps> = ({ gameData }) => {
  const {
    J_opponentName,
    scoreOurName,
    scoreWeAreHome,
    homeScore,
    awayScore,
    homeRunsByInning,
    awayRunsByInning,
  } = gameData;
  let homeTeamName;
  let awayTeamName;
  if (scoreWeAreHome) {
    homeTeamName = scoreOurName;
    awayTeamName = J_opponentName;
  } else {
    homeTeamName = J_opponentName;
    awayTeamName = scoreOurName;
  }
  let headers;
  if ((homeRunsByInning?.length || 0) > (awayRunsByInning?.length || 0)) {
    headers = ['Team']
      .concat(
        (homeRunsByInning || []).map((_, inning: number) =>
          (inning + 1).toString()
        )
      )
      .concat(['R']);
  } else {
    headers = ['Team']
      .concat(
        (awayRunsByInning || []).map((_, inning: number) =>
          (inning + 1).toString()
        )
      )
      .concat(['R']);
  }

  const homeRow = [homeTeamName]
    .concat(
      homeRunsByInning
        ? homeRunsByInning.map((runs: number[]) => runs?.toString() || '0')
        : []
    )
    .concat([homeScore?.toString() || '']);

  const awayRow = [awayTeamName]
    .concat(
      awayRunsByInning
        ? awayRunsByInning.map((runs: number[]) => runs?.toString() || '0')
        : []
    )
    .concat([awayScore?.toString() || '']);
  const scoresTable = (
    <Table>
      <TableHeader>
        <TableRow>
          {headers.map((inning) => (
            <TableCell
              key={`inning-header-${inning}`}
              scope="col"
              border="bottom"
            >
              <Text weight="bold">{inning}</Text>
            </TableCell>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow key="away-row">
          {awayRow.map((x, i) => (
            <TableCell key={`runs-${i + 1}`}>
              <Text>{x}</Text>
            </TableCell>
          ))}
        </TableRow>
        <TableRow key="home-row">
          {homeRow.map((x, i) => (
            <TableCell key={`runs-${i + 1}`}>
              <Text>{x}</Text>
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  );
  return <Box margin={{ top: 'medium' }}>{scoresTable}</Box>;
};

export default ScoreByInning;
